import { configureStore } from "@reduxjs/toolkit";
import collectionReducer from "./redux/reducers/collectionReducer";

const store = configureStore({
  reducer: {
    collection: collectionReducer,
  },
});

export default store